<template>
  <el-dialog
    :visible="visible"
    v-on:close="$emit('update:visible', false)"
    width="470px"
    class="upgrade-plan-modal"
    role="dialog"
    title="Upgrade your Harness experience"
    aria-labelledby="dialog-title"
    aria-describedby="dialog-description"
  >
    <div class="flex flex-col gap-4">
      <div id="dialog-description">
        From advice on social media best practices to fundraising strategy roadmaps, 
        Harness has a plan that fits your nonprofit's unique needs.
      </div>
      <div v-for="(text, index) in iconCards" :key="index" class="text-black">
        <icon-card
          :title="text"
          icon="check-circle"
        />
      </div>
      <div>
        Book a call with sales to discover a plan to elevate your nonprofit to new levels.
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <div class="flex justify-between">
        <a
          role="button"
          class="w-full flex items-center justify-center el-button--dark el-button--large font-bold text-white hover:text-white p-4 bg-black mt-6"
          href="https://harnessapp.outrch.com/calendar/team/t/63"
          @click="handleCtaClick"
          target="_blank"
        >
          Book a call
        </a>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import * as amplitude from "@amplitude/analytics-browser";
import { mapState } from 'vuex';

import IconCard from './icon-card.vue';
export default {
  name: "upgrade-plan-modal",
  components: { IconCard },
  props: {
    visible: {
      type: Boolean,
      default: true
    },
  },
  computed: {
    ...mapState({
      activeCharityId: (state) => state.auth.activeCharityId,
    }),
  },
  watch: {
    visible(newValue) {
      // if visible, trigger amplitude tracking event
      if (newValue) {
        amplitude.track({
          event_type: 'CTA Viewed',
          event_properties: {
            action: 'upgrade-discovery modal viewed',
          },
          groups: { charityId: this.activeCharityId },
        });
      }
    }
  },
  methods: {
    handleCtaClick() {
      amplitude.track({
        event_type: 'Button Clicked',
        event_properties: {
          action: 'upgrade-discovery modal clicked',
        },
        groups: { charityId: this.activeCharityId },
      });
      this.$emit('update:visible', false)
    },
  },
  data() {
    return {
      iconCards: [
        "Harness Platform Support",
        "Nonprofit Fundraising Expertise",
        "Marketing Development",
      ],
    };
  }
}
</script>

<style lang="scss">
  .upgrade-plan-modal {
    .el-dialog {
      border-radius: 1rem;
      padding: 1.5rem;
      @media (max-width: 768px) {
        margin-top: 2rem !important;
      }
      .el-dialog__header {
        background-color: white;
        padding: 1.5rem 0 1rem 0;
        .el-dialog__title {
          color: #050709;
          font-weight: 700;
          font-size: 1.5rem;
          padding-top: 0.5rem;
          display: block;
        };
        .el-dialog__close {
          color: #999999;
          font-size: 1.5rem;
          font-weight: 600;
          padding: 1.33rem;
          margin-right: -1.33rem;
          margin-top: -1.33rem;

          &:hover {
            color: #999999;
            background-color: #f0f0f0;
            border-radius: 100%;
          };
        };
      };
      .el-dialog__body {
        padding: 0;
        font-size: 1em;
        color: #495057;
      };
      .el-dialog__footer {
        padding: 0;
        background-color: white;
        .el-button--large {
          border-radius: 0.75rem;
        };
      };
    };
  }
</style>